import React from 'react'
import EspecialCardMenu from '../../../shared/components/especial_card_menu/especial_card_menu'

const Location = ({ property }) => {

  return (
    <EspecialCardMenu title={'Ubicación'} className='mb-3'>
    <div className="">
      <div className="mapouter">
        <div className="gmap_canvas">
          <iframe title='map' width="100%" height="100%" id="gmap_canvas" src={`https://maps.google.com/maps?q=${property?.data?.latitude},${property?.data?.longitude}&t=&z=15&ie=UTF8&iwloc=&output=embed`} frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
        </div>
      </div>
      </div>
      {/* <a className='btn contained-green w-100 no-border-radius mt-2 h-62 total-center' href={`https://maps.google.com/maps?q=${property?.address}&t=&z=15&ie=UTF8&iwloc=&output=embed`} target='_blank'>
        <h3 className='mb-0'>Ver en Google maps</h3>
      </a> */}
    </EspecialCardMenu>
  )
}
export default Location
